import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { BillType } from "../../../interfaces/BillInterfaces";
import getClientBills from "../services/clients";
import { RootState } from "../../../store";
import { notificationAdd } from "../../../actions/notification";
import addNotificationContent from "../actions/notification";
import { commonErrorMessage } from "../../../helpers/messages";
import GroupBillsByDate from "../functions/bills";

const useClientBills = (): { bills: { [key: string]: BillType[] }; isLoading: boolean } => {
  const dispatch = useDispatch();
  const [bills, setBills] = React.useState<BillType[]>([]);
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const clientId = useSelector((state: RootState) => state.clientPortalUserInfo.user.user.id);
  const getBills = React.useCallback(async () => {
    setIsLoading(true);
    try {
      const res = await getClientBills(clientId);
      setBills(res);
    } catch (error) {
      dispatch(notificationAdd(addNotificationContent(commonErrorMessage, "error")));
    } finally {
      setIsLoading(false);
    }
  }, [clientId, dispatch]);

  React.useEffect(() => {
    if (clientId) {
      getBills();
    }
  }, [clientId, getBills]);
  return { bills: GroupBillsByDate(bills), isLoading };
};

export default useClientBills;
